import { render, staticRenderFns } from "./DropTemplates.vue?vue&type=template&id=ff0640c0&scoped=true"
import script from "./DropTemplates.vue?vue&type=script&lang=js"
export * from "./DropTemplates.vue?vue&type=script&lang=js"
import style0 from "./DropTemplates.vue?vue&type=style&index=0&id=ff0640c0&prod&lang=scss&scoped=true"
import style1 from "./DropTemplates.vue?vue&type=style&index=1&id=ff0640c0&prod&lang=scss"
import style2 from "./DropTemplates.vue?vue&type=style&index=2&id=ff0640c0&prod&lang=scss"
import style3 from "./DropTemplates.vue?vue&type=style&index=3&id=ff0640c0&prod&lang=scss&scoped=true"
import style4 from "./DropTemplates.vue?vue&type=style&index=4&id=ff0640c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0640c0",
  null
  
)

export default component.exports